import { useQuery } from '@tanstack/react-query';
import { getPromptFanout } from '../../../services/monitor/features/MonitorFeaturesService';
import { GET_PROMPT_FANOUT } from '../../../query/monitor/features/keys';
import { PromptFanoutResponse } from '../../../../models/monitor/ResponseFeatures';

export interface PromptFanoutParams {
  monitorId: number;
  from: Date | null;
  to: Date | null;
  models?: string[];
  limit?: number;
}

export const useGetPromptFanout = (params: PromptFanoutParams | null) => {
  const fromTimestamp = params?.from?.getTime() ?? null;
  const toTimestamp = params?.to?.getTime() ?? null;

  const query = useQuery<PromptFanoutResponse>({
    queryKey: [
      GET_PROMPT_FANOUT,
      params?.monitorId,
      fromTimestamp,
      toTimestamp,
      params?.models,
      params?.limit,
    ],
    queryFn: () => {
      if (!params || !params.from || !params.to) {
        throw new Error('Params with dates are required');
      }
      return getPromptFanout(params.monitorId, params.from, params.to, params.models, params.limit);
    },
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
    refetchOnWindowFocus: false,
    enabled: !!params && !!params.from && !!params.to && !!params.monitorId,
  });

  return {
    fanout: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
